import { createStore, compose, applyMiddleware } from "redux";
import invariant from "redux-immutable-state-invariant";
import thunk from "redux-thunk";
import rootReducer from "./reducers";

import initialState from "./reducers/initialState";

//FIXME: remove invariant and devtools from the configure when building for production
export default function configureStore() {
    return createStore(
        rootReducer,
        initialState.loadInitials(),
        compose(
            applyMiddleware(thunk, invariant())
            // ,
            // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
            //FIXME: This is to be used ONLY in development and should be commented on creating pull requests
        )
    );
}
